import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../Icon';

export interface Breadcrumb {
  label: string;
  link: string;
}

interface BreadcrumbsProps {
  items: Breadcrumb[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
}: BreadcrumbsProps) => {
  return (
    <div className="mb-6 flex w-full items-center space-x-1">
      {items.map(({ link, label }, idx) => (
        <React.Fragment key={link}>
          {idx !== items.length - 1 ? (
            <Link
              key={link}
              to={{ search: link }}
              className="ml-1 hover:text-blue-100 hover:underline"
            >
              {label}
            </Link>
          ) : (
            <div>{label}</div>
          )}
          <span className="h-3 w-3 last:hidden">
            <Icon name="ArrowRight"></Icon>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};
